import { useErrorStore } from "./store"

export * from "./store"

export const errorStoreActions = useErrorStore.getState().errorActions
